import ResumeRegisterForm from "@/app/(resume)/_components/ResumeRegisterForm";
import { toast } from "@/app/providers";
import { postRequestApplyJob } from "@/services/api/personal";
import { Button, Divider, Select, Stack, Text } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";

export default function ResumesModal({
  jobId = "",
  jobTitle = "",
  jobPositions = [],
  close = () => {},
  setAppliedSuccessfully = () => {},
}) {
  const { t, i18n } = useTranslation();

  const [selectedJobPosition, setSelectedJobPosition] = useState(0);

  const mutation = useMutation((apply) => postRequestApplyJob(apply));

  const onApplyJobClick = () => {
    const payload = {
      job: jobId,
      applyPosition: jobPositions[selectedJobPosition]._id,
    };

    mutation.mutate(payload, {
      onSuccess: () => {
        setAppliedSuccessfully(true);
        toast({
          title: t("Apply success"),
          status: "success",
        });
        close();
      },
    });
  };

  const getListPosition = (positions) => {
    return positions
      .map(
        (position) =>
          position?.duty?.name?.[i18n.language] +
          " - " +
          position?.career?.name?.[i18n.language]
      )
      .join(", ");
  };

  return (
    <Stack gap={10}>
      <Text as="strong" fontSize="lg" textAlign="center">
        입사지원을 위해 이력서 입력정보를 확인 하세요
      </Text>
      <Stack gap={3}>
        <Stack
          bgColor="faded"
          px={4}
          py={3}
          rounded="md"
          position="sticky"
          top={0}
          zIndex={2}
        >
          <Text fontSize="xs">{t("Apply for the position: ")}</Text>
          {jobPositions.length ? (
            <Select
              fontWeight="semibold"
              bgColor="white"
              value={selectedJobPosition}
              onChange={(e) => setSelectedJobPosition(e.target.value)}
            >
              {jobPositions.map((position, index) => (
                <option key={index} value={index}>
                  {getListPosition([position])}
                </option>
              ))}
            </Select>
          ) : (
            <Text as="strong" fontSize="lg">
              {jobTitle}
            </Text>
          )}
        </Stack>
        <Divider />
        <ResumeRegisterForm hideHeader onSubmitSuccess={onApplyJobClick} />
      </Stack>
      <Button
        type="submit"
        form="resume-form"
        position="sticky"
        bottom={0}
        flexGrow={1}
        isDisabled={mutation.isLoading}
      >
        {t("Apply btn")}
      </Button>
    </Stack>
  );
}
